import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap, first } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/takeUntil';
import { User } from '../models/user';

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json'
    })
};


@Injectable({
  providedIn: 'root'
})
export class AuthorizationService implements OnDestroy {
  loggedIn = false;
  private userDetailSource = new BehaviorSubject('false');
  currentUser = this.userDetailSource.asObservable();
  private isLoginSource = new BehaviorSubject(false);
  isLoggedIn = this.isLoginSource.asObservable();
  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: any,
    private toastrService: ToastrService,
    private httpClient: HttpClient
  ) { }

  ngOnDestroy() { }

  login(loginForm): Observable<User[]> {
    return this.httpClient.post<any>(`login`, loginForm, httpOptions)
      .pipe(tap(res => {
        if (res && res.apiToken) {
          this.setCurrentUser(res.user, res['apiToken']);
        }
        return res;
      }));
  }


  forgotPasssword(formValue): Observable<any[]> {
    return this.httpClient.post<any>(`forgot-password`, formValue, httpOptions)
      .pipe(tap((res) => {
        // this.toastrService.success(res.MESSAGE);
        return true;
      }));
  }

  resendEmailVerification(email: string, code: string): Observable<any> {
    // const form = new FormData();
    // form.append('email', email);
   const  obj= {
    email: email,
    code: code
    }
    return this.httpClient.post<any>(`send_email_varification`,obj, httpOptions)
      .pipe(tap(() => {
        return true;
      }));
  }

  validateEmail(data): Observable<any> {

    return this.httpClient.post<any>(`validate`,data, httpOptions)
      .pipe(tap(() => {
        return true;
      }));
  }

  checkIfSessionExists() {
    return this.httpClient.get<any>('token', httpOptions)
      .pipe(tap((token) => {
        if (!token) {
          this.resetStatus();
          return false;
        } else {
          return true;
        }
      }));
  }

  resetStatus() {
    this.localStorage.removeItem('loggedUser');
    this.localStorage.removeItem('token');
    this.userDetailSource.next(JSON.stringify({}));
    this.loggedIn = false;
    this.isLoginSource.next(false);
  }

  setCurrentUser(user: User, token = '') {
    const userDetials = this.buildUserDetails(user);
    this.loggedIn = true;
    this.localStorage.setItem('loggedUser', JSON.stringify(userDetials));
    if (token) {
      this.localStorage.setItem('token', token);
    }
    this.isLoginSource.next(true);
    this.userDetailSource.next(JSON.stringify(userDetials));
  }

  private buildUserDetails(res: User) {
    return {
      'id': res.id,
      'balance': res.balance,
      'email': res.email
    };
  }

  resetPassword(formValue): Observable<any[]> {
    return this.httpClient.post<any>(`reset-password`, formValue, httpOptions)
      .pipe(tap(() => {
        return true;
      }));
  }

  changePassword(formValue): Observable<any[]> {
    return this.httpClient.post<any>('change-password', formValue, httpOptions)
      .pipe(tap(() => {
        return true;
      }));
  }

  signup(formValue): Observable<any[]> {
    return this.httpClient.post<any>(`register`, formValue, httpOptions)
      .pipe(tap(res => {
        // this.toastrService.success('Succeed');
      }),
        map(res => res), first());
  }

  logout() {
    // return this.httpClient.post<any>(`client_logout`, {}, httpOptions)
    //   .pipe(tap(() => {
        // this.toastrService.success('Logout successful.');
        this.resetStatus();
      // }));
  }


  retrieveUserDetails() {
    return JSON.parse(this.localStorage.getItem('loggedUser'));
  }

  retrieveUserDetailsId() {
    return JSON.parse(this.localStorage.getItem('loggedUser'))['id'];
  }
  getToken() {
    return this.localStorage.getItem('token');
  }

  setProfileData(data: any) {
    let loggedUserObj = this.localStorage.getItem('loggedUser');
    loggedUserObj = JSON.parse(loggedUserObj);
    Object.assign(loggedUserObj, data);
    this.localStorage.setItem('loggedUser', JSON.stringify(loggedUserObj));
    this.userDetailSource.next(JSON.stringify(loggedUserObj));
  }
}
